// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../../bs-utils/src/ArrayUtils.bs.js");
var CommandContext$SmartcutsMacros = require("../CommandContext.bs.js");
var Selection__StrictSelection$SmartcutsMacros = require("../Selection/Selection__StrictSelection.bs.js");
var GenericCommandWithContextGlobal$SmartcutsMacros = require("../GenericCommandWithContextGlobal.bs.js");
var SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros = require("../SelectionSemantics/SelectionSemantics__StrictSelectionSemantics.bs.js");

function t_encode(encoder_command, v) {
  return [
          "CommandLog",
          Decco.listToJson((function (param) {
                  return GenericCommandWithContextGlobal$SmartcutsMacros.t_encode(encoder_command, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode, param);
                }), v._0)
        ];
}

function t_decode(decoder_command, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "CommandLog") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.listFromJson((function (param) {
            return GenericCommandWithContextGlobal$SmartcutsMacros.t_decode(decoder_command, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_decode, param);
          }), Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* CommandLog */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function map(mapCommandWithContext, commandLogRef) {
  return /* CommandLog */{
          _0: Belt_List.map(commandLogRef._0, mapCommandWithContext)
        };
}

function stringify(stringifyCommand, cmdVal) {
  return "CommandLog([" + (Belt_Array.map($$Array.of_list(cmdVal._0), (function (param) {
                    return "{id: " + (String(param.id) + (", command: " + (Curry._1(stringifyCommand, param.command) + ("commandContext: " + (CommandContext$SmartcutsMacros.CommandContextGlobalResolved.stringify(param.contextGlobal) + "}")))));
                  })).join(", ") + "])");
}

var CommandLogRef = {
  t_encode: t_encode,
  t_decode: t_decode,
  map: map,
  stringify: stringify
};

function t_encode$1(encoder_command, v) {
  if (v) {
    return [
            "ExecuteCommands",
            t_encode(encoder_command, v._0)
          ];
  } else {
    return ["DoNothing"];
  }
}

function t_decode$1(decoder_command, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DoNothing" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DoNothing */0
                  };
          }
      case "ExecuteCommands" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode(decoder_command, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* ExecuteCommands */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function map$1(mapCommandWithContext, action) {
  if (action) {
    return /* ExecuteCommands */{
            _0: map(mapCommandWithContext, action._0)
          };
  } else {
    return /* DoNothing */0;
  }
}

function selectorGet(getSelectorInCommand, action) {
  if (!action) {
    return [];
  }
  var arg = $$Array.of_list(action._0._0);
  var param = function (param$1) {
    return Curry._1(getSelectorInCommand, param$1.command);
  };
  return ArrayUtils$SmartcutsMacros.flatMap(param, arg);
}

function stringify$1(stringifyCommand, action) {
  if (action) {
    return "ExecuteCommands(" + (stringify(stringifyCommand, action._0) + ")");
  } else {
    return "DoNothing";
  }
}

function someCommands(f, action) {
  if (action) {
    return Belt_List.some(action._0._0, f);
  } else {
    return false;
  }
}

var SwitchAction = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  map: map$1,
  selectorGet: selectorGet,
  stringify: stringify$1,
  someCommands: someCommands
};

function selectionExistsPredicate_encode(v) {
  return Js_dict.fromArray([
              [
                "semantic",
                SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.t_encode(v.semantic)
              ],
              [
                "originalSelection",
                Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_encode(v.originalSelection)
              ]
            ]);
}

function selectionExistsPredicate_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var semantic = SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantic"), null));
  if (semantic.TAG === /* Ok */0) {
    var originalSelection = Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalSelection"), null));
    if (originalSelection.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                semantic: semantic._0,
                originalSelection: originalSelection._0
              }
            };
    }
    var e = originalSelection._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".originalSelection" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = semantic._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".semantic" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode$2(v) {
  if (v.TAG === /* SelectorExists */0) {
    return [
            "SelectorExists",
            Selector$SmartcutsMacros.selector_encode(v._0)
          ];
  } else {
    return [
            "SelectionExists",
            selectionExistsPredicate_encode(v._0)
          ];
  }
}

function t_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "SelectionExists" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = selectionExistsPredicate_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectionExists */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SelectorExists" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectorExists */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function mapSelector(f, predicate) {
  if (predicate.TAG === /* SelectorExists */0) {
    return {
            TAG: /* SelectorExists */0,
            _0: Curry._1(f, predicate._0)
          };
  }
  var match = predicate._0;
  var func = SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.updateSelector;
  var func$1 = Selection__StrictSelection$SmartcutsMacros.ForNonRecording.updateSelector;
  return {
          TAG: /* SelectionExists */1,
          _0: {
            semantic: Curry._2(func, f, match.semantic),
            originalSelection: Curry._2(func$1, f, match.originalSelection)
          }
        };
}

function stringify$2(predicate) {
  if (predicate.TAG === /* SelectorExists */0) {
    return "SelectorExists(" + (Selector$SmartcutsMacros.stringify(undefined, false, predicate._0) + ")");
  } else {
    return "SelectionExists({originalSelection, semantic: " + (SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.stringify(predicate._0.semantic) + "})");
  }
}

var Predicate = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  selectionExistsPredicate_encode: selectionExistsPredicate_encode,
  selectionExistsPredicate_decode: selectionExistsPredicate_decode,
  mapSelector: mapSelector,
  stringify: stringify$2
};

function t_encode$3(encoder_command, v) {
  if (v) {
    return [
            "SwitchAction",
            t_encode$1(encoder_command, v._0)
          ];
  } else {
    return ["FailWithNoPredicateSatisfied"];
  }
}

function t_decode$3(decoder_command, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "FailWithNoPredicateSatisfied" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FailWithNoPredicateSatisfied */0
                  };
          }
      case "SwitchAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$1(decoder_command, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* SwitchAction */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function map$2(mapCommandWithContext, v) {
  if (v) {
    return /* SwitchAction */{
            _0: map$1(mapCommandWithContext, v._0)
          };
  } else {
    return /* FailWithNoPredicateSatisfied */0;
  }
}

function someCommands$1(f, v) {
  if (v) {
    return someCommands(f, v._0);
  } else {
    return false;
  }
}

var SwitchActionOrFailure = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  map: map$2,
  someCommands: someCommands$1
};

function t_encode$4(encoder_command, v) {
  return Js_dict.fromArray([
              [
                "predicate",
                t_encode$2(v.predicate)
              ],
              [
                "action",
                t_encode$1(encoder_command, v.action)
              ]
            ]);
}

function t_decode$4(decoder_command, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var predicate = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "predicate"), null));
  if (predicate.TAG === /* Ok */0) {
    var action = t_decode$1(decoder_command, Belt_Option.getWithDefault(Js_dict.get(dict$1, "action"), null));
    if (action.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                predicate: predicate._0,
                action: action._0
              }
            };
    }
    var e = action._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".action" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = predicate._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".predicate" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function mapSelector$1(f, mapCommandWithContext, param) {
  return {
          predicate: mapSelector(f, param.predicate),
          action: map$1(mapCommandWithContext, param.action)
        };
}

var PredicateAndAction = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  mapSelector: mapSelector$1
};

function t_encode$5(encoder_command, v) {
  return Js_dict.fromArray([
              [
                "clauses",
                Decco.arrayToJson((function (param) {
                        return t_encode$4(encoder_command, param);
                      }), v.clauses)
              ],
              [
                "default",
                t_encode$3(encoder_command, v.default)
              ]
            ]);
}

function t_decode$5(decoder_command, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var clauses = Decco.arrayFromJson((function (param) {
          return t_decode$4(decoder_command, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "clauses"), null));
  if (clauses.TAG === /* Ok */0) {
    var $$default = t_decode$3(decoder_command, Belt_Option.getWithDefault(Js_dict.get(dict$1, "default"), null));
    if ($$default.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                clauses: clauses._0,
                default: $$default._0
              }
            };
    }
    var e = $$default._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".default" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = clauses._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".clauses" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function map$3(mapCommandWithContext, param) {
  var $$default = param.default;
  return {
          clauses: Belt_Array.map(param.clauses, (function (param) {
                  return {
                          predicate: param.predicate,
                          action: map$1(mapCommandWithContext, param.action)
                        };
                })),
          default: $$default ? /* SwitchAction */({
                _0: map$1(mapCommandWithContext, $$default._0)
              }) : /* FailWithNoPredicateSatisfied */0
        };
}

function getIdentifier(param) {
  return "switch([" + (Belt_Array.map(param.clauses, (function (param) {
                    var predicate = param.predicate;
                    if (predicate.TAG === /* SelectorExists */0) {
                      return "SelectorExists(" + (Selector$SmartcutsMacros.stringify(undefined, false, predicate._0) + ")");
                    }
                    var match = Selection__StrictSelection$SmartcutsMacros.Generic.extractTexts(predicate._0.originalSelection);
                    return "SelectionExists(" + (match[1] + ")");
                  })).join(",") + ("],default:" + ((
                param.default ? "SwitchAction" : "FailWithNoPredicateSatisfied"
              ) + ")")));
}

function stringify$3(stringifyCommand, param) {
  var $$default = param.default;
  return "{ clauses: [" + (Belt_Array.map(param.clauses, (function (param) {
                    var predicateString = stringify$2(param.predicate);
                    var actionString = stringify$1(stringifyCommand, param.action);
                    return predicateString + (" => " + actionString);
                  })).join(", ") + ("], default: " + ((
                $$default ? "SwitchAction(" + (stringify$1(stringifyCommand, $$default._0) + ")") : "FailWithNoPredicateSatisfied"
              ) + " }")));
}

function selectorGet$1(getSelectorInCommand, param) {
  var $$default = param.default;
  return Belt_Array.concat(ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                    var predicate = param.predicate;
                    var tmp;
                    tmp = predicate.TAG === /* SelectorExists */0 ? [predicate._0] : Selection__StrictSelection$SmartcutsMacros.ForNonRecording.extractSelectors(predicate._0.originalSelection);
                    return Belt_Array.concat(selectorGet(getSelectorInCommand, param.action), tmp);
                  }), param.clauses), $$default ? selectorGet(getSelectorInCommand, $$default._0) : []);
}

function mapSelector$2(f, mapCommandWithContext, param) {
  return {
          clauses: Belt_Array.map(param.clauses, (function (predicateAndAction) {
                  return mapSelector$1(f, mapCommandWithContext, predicateAndAction);
                })),
          default: map$2(mapCommandWithContext, param.default)
        };
}

function someCommands$2(f, param) {
  if (Belt_Array.some(param.clauses, (function (param) {
            return someCommands(f, param.action);
          }))) {
    return true;
  } else {
    return someCommands$1(f, param.default);
  }
}

var CommandValue = {
  Predicate: Predicate,
  SwitchActionOrFailure: SwitchActionOrFailure,
  PredicateAndAction: PredicateAndAction,
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  map: map$3,
  getIdentifier: getIdentifier,
  stringify: stringify$3,
  selectorGet: selectorGet$1,
  mapSelector: mapSelector$2,
  someCommands: someCommands$2
};

exports.CommandLogRef = CommandLogRef;
exports.SwitchAction = SwitchAction;
exports.CommandValue = CommandValue;
/* Selector-SmartcutsMacros Not a pure module */
